import { CheckoutProvider } from "@/context";
import { Box, Modal } from "@biom3/react";
import { useConnection } from "@hooks/connection";
import { ConnectWalletWidget } from "./ConnectWalletWidget";

type Props = {
  isModalOpen: boolean;
  onClose: () => void;
};

export function WalletWidget({ isModalOpen, onClose }: Props) {
  const { connect } = useConnection();

  return (
    <Modal
      visible={isModalOpen}
      testId="wallet-modal"
      position={{
        x: "center",
        y: "center",
      }}
      fullScreenUntilBreakpoint="small"
    >
      <Modal.Content>
        <Box testId="wallet-modal--modalContent">
          <CheckoutProvider>
            <ConnectWalletWidget onClose={onClose} connect={connect} />
          </CheckoutProvider>
        </Box>
      </Modal.Content>
    </Modal>
  );
}
